const contractDurations = [
  {
    name: "Unlimited",
    value: "UNLIMITED",
  },
  {
    name: "Limited",
    value: "LIMITED",
  },
  {
    name: "Other",
    value: "OTHER",
  },
];

export default contractDurations;
